module.exports = __webpack_public_path__ + "static/img/logo_2.3b6eaad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_2.png
// module id = Z9TY
// module chunks = 1